/**
 * @file: This file holds the colours the app uses when data gives none.
 *
 * A scene has a colour and a kind label has a colour. Both can be missing. A
 * deleted scene keeps its log rows, and a media can have no kind. The two
 * places wrote the same grey twice, so a change of the grey changed one page
 * and not the other. The value is here, and both read it.
 */

/** The dot of a scene or a kind the app cannot name keeps this grey. */
const NEUTRAL_GREY = '#adb5bd'

export { NEUTRAL_GREY }
